const papersDataEdexcelGcse = {
  mathematics: [
    {
      year: '2023',
      papers: [
        {
          label: '1F',
          link:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EdM23F1P1ma1-1f-que-20230520.pdf',
          marking:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EdM23F1MS1ma1-1f-rms-20230824.pdf',
        },
        {
          label: '1H',
          link:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EdM23H1P1ma1-1h-que-20230520.pdf',
          marking:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EdM23H1MS1ma1-1h-rms-20230824.pdf',
        },
        {
          label: '2F',
          link:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EdM23F2P1ma1-2f-que-20230608.pdf',
          marking:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EdM23F2MS1ma1-2f-rms-20230824.pdf',
        },
        {
          label: '2H',
          link:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EdM23H2P1ma1-2h-que-20230608.pdf',
          marking:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EdM23H2MS1ma1-2h-rms-20230824.pdf',
        },
        {
          label: '3F',
          link:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EdM23F3P1ma1-3f-que-20230615.pdf',
          marking:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EdM23F3MS1ma1-3f-rms-20230824.pdf',
        },
        {
          label: '3H',
          link:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EdM23H3P1ma1-3hque-20230615.pdf',
          marking:
            'https://revisionmaths.com/sites/default/files/revisionmaths/documents/EdM23H3MS1ma1-3h-rms-20230824.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1F',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-1f-que-20220521.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-1f-rms-20220825.pdf',
        },
        {
          label: '1H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-1h-que-20220521.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-1h-rms-20220825.pdf',
        },
        {
          label: '2F',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-2f-que-20220608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-2f-rms-20220825.pdf',
        },
        {
          label: '2H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-2h-que-20220608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-2h-rms-20220825.pdf',
        },
        {
          label: '3F',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-3f-que-20220614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-3f-rms-20220825.pdf',
        },
        {
          label: '3H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-3h-que-20220614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-3h-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1F',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-1f-que-20211103.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-1f-rms-20220113.pdf',
        },
        {
          label: '1H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-1h-que-20211103.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-1h-rms-20220113.pdf',
        },
        {
          label: '2F',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-2f-que-20211105.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-2f-rms-20220113.pdf',
        },
        {
          label: '2H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-2h-que-20211105.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-2h-rms-20220113.pdf',
        },
        {
          label: '3F',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-3f-que-20211109.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-3f-rms-20220113.pdf',
        },
        {
          label: '3H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-3h-que-20211109.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-3h-rms-20220113.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1F',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/1MA1_1F_que_20201104_0.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/1MA1_1F_msc_20210114_0.pdf',
        },
        {
          label: '1H',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/1MA1_1H_que_20201104.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/1MA1_1H_msc_20210114.pdf',
        },
        {
          label: '2F',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/1MA1_2F_que_20201106.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/1MA1_2F_msc_20210114.pdf',
        },
        {
          label: '2H',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/1MA1_2H_que_20201106.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/1MA1_2H_msc_20210114.pdf',
        },
        {
          label: '3F',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/1MA1_3F_que_20201110.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/1MA1_3F_msc_20210114.pdf',
        },
        {
          label: '3H',
          link:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/1MA1_3H_que_20201110.pdf',
          marking:
            'https://revisionmaths.com/sites/mathsrevision.net/files/imce/1MA1_3H_msc_20210114.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1F',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1MA1_1F_que_20190522.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1MA1_1F_rms_20190822.pdf',
        },
        {
          label: '1H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1MA1_1H_que_20190522.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1MA1_1H_rms_20190822.pdf',
        },
        {
          label: '2F',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1MA1_2F_que_20190607.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1ma1-2f-rms-20190822.pdf',
        },
        {
          label: '2H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1MA1_2H_que_20190607.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1MA1_2H_rms_20190822.pdf',
        },
        {
          label: '3F',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1MA1_3F_que_20190612.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1MA1_3F_rms_20190822.pdf',
        },
        {
          label: '3H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1MA1_3H_que_20190612.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/mathematics/2015/exam-materials/1MA1_3H_rms_20190822.pdf',
        },
      ],
    },
  ],
  combinedscience: [
    {
      year: '2023',
      papers: [
        {
          label: '1BF',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCF311sc0-1bf-que-20230517.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCF321sc0-1bf-rms-20230824.pdf',
        },
        {
          label: '1CF',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCF331sc0-1cf-que-20230523.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCF341sc0-1cf-rms-20230824.pdf',
        },
        {
          label: '1PF',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCF351sc0-1pf-que-20230526.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCF361sc0-1pf-rms-20230824.pdf',
        },
        {
          label: '2BF',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCF371sc0-2bf-que-20230610.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCF381sc0-2bf-rms-20230824.pdf',
        },
        {
          label: '2CF',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCF391sc0-2cf-que-20230614.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCF3101sc0-2cf-rms-20230824.pdf',
        },
        {
          label: '2PF',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCF3111sc0-2pf-que-20230617.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCF3121sc0-2pf-rms-20230824.pdf',
        },
        {
          label: '1BH',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCH311sc0-1bh-que-20230517.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCH321sc0-1bh-rms-20230824.pdf',
        },
        {
          label: '1CH',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCH331sc0-1ch-que-20230523.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCH341sc0-1ch-rms-20230824.pdf',
        },
        {
          label: '1PH',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCH351sc0-1ph-que-20230526.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCH361sc0-1ph-rms-20230824.pdf',
        },
        {
          label: '2BH',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCH371sc0-2bh-que-20230610.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCH381sc0-2bh-rms-20230824.pdf',
        },
        {
          label: '2CH',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCH391sc0-2ch-que-20230614.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCH3111sc0-2ch-rms-20230824.pdf',
        },
        {
          label: '2PH',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCH3101sc0-2ph-que-20230617.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/ESCH3121sc0-2ph-rms-20230824.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1BF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1bf-que-20220518.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1bf-rms-20220825.pdf',
        },
        {
          label: '1CF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1cf-que-20220528.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1cf-rms-20220825.pdf',
        },
        {
          label: '1PF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1pf-que-20220610.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1pf-rms-20220825.pdf',
        },
        {
          label: '2BF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2bf-que-20220616.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2bf-rms-20220825.pdf',
        },
        {
          label: '2CF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2cf-que-20220621.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2cf-rms-20220825.pdf',
        },
        {
          label: '2PF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2pf-que-20220624.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2pf-rms-20220825.pdf',
        },
        {
          label: '1BH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1bh-que-20220518.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1bh-rms-20220825.pdf',
        },
        {
          label: '1CH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1ch-que-20220528.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1ch-rms-20220825.pdf',
        },
        {
          label: '1PH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1ph-que-20220610.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1ph-rms-20220825.pdf',
        },
        {
          label: '2BH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2bh-que-20220616.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2bh-rms-20220825.pdf',
        },
        {
          label: '2CH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2ch-que-20220621.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2ch-rms-20220825.pdf',
        },
        {
          label: '2PH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2ph-que-20220624.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2ph-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1BF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1BF_que_20211116.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1bf-rms-20220224.pdf',
        },
        {
          label: '1CF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1CF_que_20211120.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1cf-rms-20220224.pdf',
        },
        {
          label: '1PF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1PF_que_20211124.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1pf-rms-20220224.pdf',
        },
        {
          label: '2BF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2BF_que_20211127.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2bf-rms-20220224.pdf',
        },
        {
          label: '2CF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2CF_que_20211130.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2cf-rms-20220224.pdf',
        },
        {
          label: '2PF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2PF_que_20211202.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2pf-rms-20220224.pdf',
        },
        {
          label: '1BH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1BH_que_20211116.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1bh-rms-20220224.pdf',
        },
        {
          label: '1CH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1CH_que_20211120.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1ch-rms-20220224.pdf',
        },
        {
          label: '1PH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1PH_que_20211124.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-1ph-rms-20220224.pdf',
        },
        {
          label: '2BH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2BH_que_20211127.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2bh-rms-20220224.pdf',
        },
        {
          label: '2CH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2CH_que_20211130.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2ch-rms-20220224.pdf',
        },
        {
          label: '2PH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2PH_que_20211202.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1sc0-2ph-rms-20220224.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1BF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1BF_que_20201107.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1BF_msc_20210211.pdf',
        },
        {
          label: '1CF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1CF_que_20201111.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1CF_msc_20210211.pdf',
        },
        {
          label: '1PF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1PF_que_20201114.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1PF_msc_20210211.pdf',
        },
        {
          label: '2BF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2BF_que_20201119.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2BF_msc_20210211.pdf',
        },
        {
          label: '2CF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2CF_que_20201121%281%29.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2CF_msc_20210211.pdf',
        },
        {
          label: '2PF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2PF_que_20201124.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2PF_msc_20210211.pdf',
        },
        {
          label: '1BH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1BH_que_20201107.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1BH_msc_20210211.pdf',
        },
        {
          label: '1CH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1CH_que_20201111.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1CH_msc_20210211.pdf',
        },
        {
          label: '1PH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1PH_que_20201114.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1PH_msc_20210211.pdf',
        },
        {
          label: '2BH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2BH_que_20201119.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2BH_msc_20210211.pdf',
        },
        {
          label: '2CH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2CH_que_20201121.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2CH_msc_20210211.pdf',
        },
        {
          label: '2PH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2PH_que_20201124.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2PH_msc_20210211.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1BF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1BF_que_20190515.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1BF_rms_20190822.pdf',
        },
        {
          label: '1CF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1CF_que_20190517.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1CF_rms_20190822.pdf',
        },
        {
          label: '1PF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1PF_que_20190523.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1PF_rms_20190822.pdf',
        },
        {
          label: '2BF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2BF_que_20190608.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2BF_rms_20190822.pdf',
        },
        {
          label: '2CF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2CF_que_20190613.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2CF_rms_20190822.pdf',
        },
        {
          label: '2PF',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2PF_que_20190615.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2PF_rms_20190822.pdf',
        },
        {
          label: '1BH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1BH_que_20190515.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1BH_rms_20190822.pdf',
        },
        {
          label: '1CH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1CH_que_20190517.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1CH_rms_20190822.pdf',
        },
        {
          label: '1PH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1PH_que_20190523.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_1PH_rms_20190822.pdf',
        },
        {
          label: '2BH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2BH_que_20190608.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2BH_rms_20190822.pdf',
        },
        {
          label: '2CH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2CH_que_20190613.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2CH_rms_20190822.pdf',
        },
        {
          label: '2PH',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2PH_que_20190615.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1SC0_2PH_rms_20190822.pdf',
        },
      ],
    },
  ],
  biology: [
    {
      year: '2023',
      papers: [
        {
          label: '1F',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/Science/2016/Exam-materials/1bi0-1f-que-20230517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/Science/2016/Exam-materials/1bi0-1f-rms-20230824.pdf',
        },
        {
          label: '1H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/Science/2016/Exam-materials/1bi0-1h-que-20230517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/Science/2016/Exam-materials/1bi0-1h-rms-20230824.pdf',
        },
        {
          label: '2F',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/Science/2016/Exam-materials/1bi0-2f-que-20230610.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/Science/2016/Exam-materials/1bi0-2f-rms-20230824.pdf',
        },
        {
          label: '2H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/Science/2016/Exam-materials/1bi0-2h-que-20230610.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/Science/2016/Exam-materials/1bi0-2h-rms-20230824.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1bi0-1f-que-20220518.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1bi0-1f-rms-20220825.pdf',
        },
        {
          label: '1H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1bi0-1h-que-20220518.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1bi0-1h-rms-20220825.pdf',
        },
        {
          label: '2F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1bi0-2f-que-20220616.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1bi0-2f-rms-20220825.pdf',
        },
        {
          label: '2H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1bi0-2h-que-20220616.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1bi0-2h-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_1F_que_20211116.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_1F_rms_20220224.pdf',
        },
        {
          label: '1H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_1H_que_20211116.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_1H_rms_20220224.pdf',
        },
        {
          label: '2F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_2F_que_20211127.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_2F_rms_20220224.pdf',
        },
        {
          label: '2H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_2H_que_20211127.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_2H_rms_20220224.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_1F_que_20201107.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_1F_msc_20210211.pdf',
        },
        {
          label: '1H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_2F_que_20201119.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_2F_msc_20210211.pdf',
        },
        {
          label: '2F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_1H_que_20201107.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_1H_msc_20210211.pdf',
        },
        {
          label: '2H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_2H_que_20201119.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_2H_msc_20210211.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_1F_que_20190515.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_1F_rms_20190822.pdf',
        },
        {
          label: '1H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_1H_que_20190515.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_1H_rms_20190822.pdf',
        },
        {
          label: '2F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_2F_que_20190608.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_2F_rms_20190822.pdf',
        },
        {
          label: '2H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_2H_que_20190608.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1BI0_2H_rms_20190822.pdf',
        },
      ],
    },
  ],
  chemistry: [
    {
      year: '2023',
      papers: [
        {
          label: '1F',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/Science/2016/Exam-materials/1ch0-1f-que-20230523.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/Science/2016/Exam-materials/1ch0-1f-rms-20230824.pdf',
        },
        {
          label: '1H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/Science/2016/Exam-materials/1ch0-1h-que-20230523.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/Science/2016/Exam-materials/1ch0-1h-rms-20230824.pdf',
        },
        {
          label: '2F',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/Science/2016/Exam-materials/1ch0-2f-que-20230614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/Science/2016/Exam-materials/1ch0-2f-rms-20230824.pdf',
        },
        {
          label: '2H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/Science/2016/Exam-materials/1ch0-2h-que-20230614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/GCSE/Science/2016/Exam-materials/1ch0-2h-rms-20230824.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ch0-1f-que-20220528.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ch0-1f-rms-20220825.pdf',
        },
        {
          label: '1H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ch0-1h-que-20220528.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ch0-1h-rms-20220825.pdf',
        },
        {
          label: '2F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ch0-2f-que-20220621.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ch0-2f-rms-20220825.pdf',
        },
        {
          label: '2H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ch0-2h-que-20220621.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ch0-2h-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_1F_que_20211120.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_1F_rms_20220224.pdf',
        },
        {
          label: '1H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_1H_que_20211120.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_1H_rms_20220224.pdf',
        },
        {
          label: '2F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_2F_que_20211130.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_2F_rms_20220224.pdf',
        },
        {
          label: '2H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_2H_que_20211130.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_2H_rms_20220224.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_1F_que_20201111.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_1F_msc_20210211.pdf',
        },
        {
          label: '1H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_1H_que_20201111.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_1H_msc_20210211.pdf',
        },
        {
          label: '2F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_2F_que_20201121.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_2F_msc_20210211.pdf',
        },
        {
          label: '2H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_2H_que_20201121.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_2H_msc_20210211.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_1F_que_20190517.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_1F_rms_20190822.pdf',
        },
        {
          label: '1H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_1H_que_20190517.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_1H_rms_20190822.pdf',
        },
        {
          label: '2F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_2F_que_20190613.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_2F_rms_20190822_0.pdf',
        },
        {
          label: '2H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_2H_que_20190613.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1CH0_2H_rms_20190822.pdf',
        },
      ],
    },
  ],
  physics: [
    {
      year: '2023',
      papers: [
        {
          label: '1F',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EPH311ph0-1f-que-20230526.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EPH321ph0-1f-rms-20230824.pdf',
        },
        {
          label: '1H',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EPH331ph0-1h-que-20230526.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EPH341ph0-1h-rms-20230824.pdf',
        },
        {
          label: '2F',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EPH351ph0-2f-que-20230617.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EPH371ph0-2f-rms-20230824.pdf',
        },
        {
          label: '2H',
          link:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EPH361ph0-2h-que-20230617.pdf',
          marking:
            'https://revisionscience.com/sites/default/files/revisionscience/documents/EPH381ph0-2h-rms-20230824.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ph0-1f-que-20220610.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ph0-1f-rms-20220825.pdf',
        },
        {
          label: '1H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ph0-1h-que-20220610.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ph0-1h-rms-20220825.pdf',
        },
        {
          label: '2F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ph0-2f-que-20220624.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ph0-2f-rms-20220825.pdf',
        },
        {
          label: '2H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ph0-2h-que-20220624.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ph0-2h-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_1F_que_20211124.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_1F_rms_20220224.pdf',
        },
        {
          label: '1H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_1H_que_20211124.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ph0-1h-rms-20220224.pdf',
        },
        {
          label: '2F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_2F_que_20211202.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ph0-2f-rms-20220224.pdf',
        },
        {
          label: '2H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_2H_que_20211202.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1ph0-2h-rms-20220224.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_1F_que_20201114.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_1F_msc_20210211.pdf',
        },
        {
          label: '1H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_1H_que_20201114.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_1H_msc_20210211.pdf',
        },
        {
          label: '2F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_2F_que_20201124.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_2F_msc_20210211.pdf',
        },
        {
          label: '2H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_2H_que_20201124.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_2H_msc_20210211.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_1F_que_20190523.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_1F_rms_20190822.pdf',
        },
        {
          label: '1H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_1H_que_20190523.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_1H_rms_20190822.pdf',
        },
        {
          label: '2F',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_2F_que_20190615.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_2F_rms_20190822.pdf',
        },
        {
          label: '2H',
          link:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_2H_que_20190615.pdf',
          marking:
            'https://revisionscience.com/sites/revisionscience.com/files/imce/1PH0_2H_rms_20190822.pdf',
        },
      ],
    },
  ],
};

export default papersDataEdexcelGcse;
